import { FreeSelect, Label } from "@gearbox-protocol/deploy-tools-ui";
import { type FC, useMemo } from "react";
import { useController } from "react-hook-form";

import { useTaskDefinitions } from "./TaskDefinitionsProvider";

export const TaskDefinitionIdInput: FC = () => {
  const { taskDefinitions, loading } = useTaskDefinitions();
  const options = useMemo(
    () => taskDefinitions.flatMap(t => (t.id ? [t.id] : [])),
    [taskDefinitions],
  );

  const { field } = useController<{ id: string }>({
    name: "id",
  });

  return (
    <>
      <Label htmlFor="alias" className="text-right">
        Definition ID
      </Label>
      <FreeSelect
        value={field.value}
        onChange={field.onChange}
        options={options}
        loading={loading}
        emptyMessage="no matching definitions"
        placeholder="Select task definition"
      />
    </>
  );
};

export default TaskDefinitionIdInput;
